import ContentArea from '../ContentArea';
import ScrollToTop from './ScrollToTop';

const Application = (props) => {
    return (
        <ScrollToTop>
            <ContentArea />
        </ScrollToTop>
    );
};

export default Application;
